/*
  786 Motion Plus - section choreography
  -------------------------------------
  Sits on top of assets/motion.js (GSAP + ScrollTrigger + Lenis).
  motion.js has a good engine, but its default selectors are Stiletto's,
  so the custom 786 sections were barely animating. This file tags every
  786 section with the right data-anim choreography and lets motion.js
  play it. Tabs and sliders live in 786-motion-tabs.js.
  Motion only - no layout or design changes.
*/
(function () {
  'use strict';

  var html = document.documentElement;
  if (html.classList.contains('motion-off')) return;

  var G = window.gsap;
  if (!G) return;

  var touch = window.matchMedia('(hover: none)').matches;

  function q(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function one(sel, root) { return (root || document).querySelector(sel); }

  /* Tag an element so motion.js animates it. Never overrides an existing tag. */
  function A(el, type, o) {
    if (!el || el.dataset.anim || el.dataset.animDone) return el;
    o = o || {};
    el.dataset.anim = type;
    if (o.delay != null) el.dataset.animDelay = o.delay;
    if (o.dur != null) el.dataset.animDuration = o.dur;
    if (o.stagger != null) el.dataset.animStagger = o.stagger;
    if (o.child) el.dataset.animChild = o.child;
    if (o.children) el.dataset.animChildren = o.children;
    if (o.from) el.dataset.animFrom = o.from;
    if (o.start) el.dataset.animStart = o.start;
    if (o.speed != null) el.dataset.animSpeed = o.speed;
    if (o.ease) el.dataset.animEase = o.ease;
    return el;
  }
  function AA(sel, root, type, o) { q(sel, root).forEach(function (el) { A(el, type, o); }); }

  /* Hover helpers are read by motion.js hoverFX() */
  function hov(sel, root, attr, val) {
    if (touch) return;
    q(sel, root).forEach(function (el) { if (!el.hasAttribute(attr)) el.setAttribute(attr, val); });
  }

  /* Slow drift on an image that is already in place (hero, campaign, VIP) */
  function kenBurns(img, amount) {
    if (!img || img.dataset.mpKb) return;
    img.dataset.mpKb = '1';
    G.fromTo(img, { scale: 1 }, {
      scale: 1 + (amount || 0.07), duration: 14, ease: 'none',
      yoyo: true, repeat: -1
    });
  }

  /* ------------------------------------------------------------ hero */
  function hero(root) {
    q('.s786-hero2', root).forEach(function (s) {
      A(one('.s786-hero2__frame', s), 'reveal-img', { dur: 1.5, start: 'top 97%' });
      A(one('.s786-hero2__title', s), 'words', { stagger: 0.055, dur: 1.05, delay: 0.25, start: 'top 97%' });
      A(one('.s786-hero2__tag', s), 'fade-up', { delay: 0.55, dur: 0.9, start: 'top 97%' });
      A(one('.s786-hero2__btn', s), 'fade-up', { delay: 0.7, dur: 0.9, start: 'top 97%' });
      var bd = one('.s786-hero2__bd img', s);
      if (bd && !bd.dataset.anim) { bd.dataset.anim = 'parallax'; bd.dataset.animSpeed = '0.16'; }
      kenBurns(one('.s786-hero2__slide.is-active .s786-hero2__pic img', s), 0.06);
      hov('.s786-hero2__btn', s, 'data-magnetic', '0.3');
      hov('.s786-hero2__arrow', s, 'data-hover-scale', '1.12');
    });
  }

  /* ------------------------------------------------------ shade wall */
  function shades(root) {
    q('.s786-shades', root).forEach(function (s) {
      A(one('.s786-h2', s), 'words', { stagger: 0.05 });
      A(one('.s786-tabs', s), 'stagger', { children: '.s786-tabs__item', child: 'fade-up', stagger: 0.06, dur: 0.75, delay: 0.15 });
      A(one('.s786-shades__wall', s), 'stagger', {
        children: '.s786-swatch', child: 'scale-in', stagger: 0.012, dur: 0.75, from: 'random', start: 'top 92%'
      });
      A(one('.s786-shades__cta', s), 'fade-up', { delay: 0.1 });
      hov('.s786-shades__cta .s786-btn', s, 'data-magnetic', '0.32');
    });
  }

  /* ------------------------------------------- product tabs carousel */
  function carousel(root) {
    q('.ptb786-carousel', root).forEach(function (s) {
      A(one('.ptb786-title', s), 'words', { stagger: 0.05 });
      A(one('.ptb786-tabs', s), 'stagger', { children: '.ptb786-tab', child: 'fade-up', stagger: 0.035, dur: 0.7, delay: 0.1 });
      A(one('.ptb786-arrows', s), 'fade-in', { delay: 0.3 });
      var live = one('.ptb786-gallery.is-active .ptb786-track', s);
      A(live, 'stagger', { children: '.ptb786-card', child: 'fade-up', stagger: 0.07, dur: 0.85, start: 'top 90%' });
      hov('.ptb786-card', s, 'data-tilt', '5');
      hov('.ptb786-arrow', s, 'data-hover-scale', '1.1');
    });
  }

  /* ------------------------------------------------ featured section */
  function featured(root) {
    q('.n786-featured-section', root).forEach(function (s) {
      A(one('.n786-heading', s), 'words', { stagger: 0.05 });
      A(one('.n786-main-card', s), 'clip-left', { dur: 1.3, start: 'top 90%' });
      A(one('.n786-main-content', s), 'stagger', { child: 'fade-up', stagger: 0.09, delay: 0.35, dur: 0.85 });
      A(one('.n786-products-track', s), 'stagger', { children: '.n786-product-card', child: 'fade-up', stagger: 0.08, dur: 0.85, start: 'top 90%' });
      kenBurns(one('.n786-main-image img', s), 0.08);
      hov('.n786-product-card', s, 'data-tilt', '5');
      hov('.n786-button', s, 'data-magnetic', '0.28');
    });
  }

  /* ---------------------------------------------------------- campaign
     The --static variant pins several children with !important, so only
     the elements it leaves free are animated here. */
  function campaign(root) {
    q('.s786-campaign', root).forEach(function (s) {
      A(one('.s786-campaign__frame', s), 'reveal-img', { dur: 1.4, start: 'top 88%' });
      A(one('.s786-campaign__model', s), 'fade-up', { dur: 1.2, delay: 0.25, start: 'top 85%' });
      A(one('.s786-campaign__strip-inner', s), 'stagger', { child: 'fade-up', stagger: 0.12, delay: 0.35, dur: 0.9 });
      A(one('.s786-campaign__tags', s), 'stagger', { child: 'scale-in', stagger: 0.07, dur: 0.6 });
      AA('.s786-campaign__card-img', s, 'scale-in', { dur: 1 });
      hov('.s786-campaign__card', s, 'data-hover-scale', '1.02');
    });
  }

  /* --------------------------------------------------------- spotlight */
  function spotlight(root) {
    q('.s786-spot', root).forEach(function (s) {
      A(one('.s786-spot__text', s), 'stagger', { child: 'fade-up', stagger: 0.1, dur: 0.9 });
      q('.s786-spot__img', s).forEach(function (img, i) {
        A(img, 'scale-in', { dur: 0.95, delay: 0.08 * i, start: 'top 92%' });
        if (!img.hasAttribute('data-float')) img.setAttribute('data-float', '');
      });
      hov('.s786-spot__img', s, 'data-hover-scale', '1.04');
    });
  }

  /* --------------------------------------------------------------- VIP */
  function vip(root) {
    q('.s786-vip', root).forEach(function (s) {
      A(one('.s786-vip__box', s), 'reveal-img', { dur: 1.25, start: 'top 90%' });
      A(one('.s786-vip__text', s), 'stagger', { child: 'fade-up', stagger: 0.1, delay: 0.3, dur: 0.85 });
      kenBurns(one('.s786-vip__img img', s), 0.07);
      hov('.s786-vip__submit', s, 'data-magnetic', '0.3');
    });
  }

  /* ------------------------------------------------------------ footer */
  function footer(root) {
    q('.s786-footer', root).forEach(function (s) {
      A(one('.s786-footer__logo', s), 'fade-up', {});
      A(one('.s786-footer__about', s), 'fade-up', { delay: 0.1 });
      A(one('.s786-footer__cols', s), 'stagger', { children: '.s786-footer__col', child: 'fade-up', stagger: 0.08 });
      A(one('.s786-footer__social', s), 'fade-up', { delay: 0.1 });
      hov('.s786-footer__icons a', s, 'data-hover-scale', '1.15');
    });
  }

  /* ------------------------------ every other template (generic pass)
     Standards page, journal, article, collection, cart, search, 404,
     about, product page - heading rises, body fades, grids stagger. */
  var GENERIC = [
    ['.st786', '.st-h2, .st-hero__title', '.st-sub, .st-hero__intro',
      '.st-badges|.st-badge, .st-certs|.st-cert, .st-gal|.st-gal__item, .st-free__list|li, .st-acc|.st-acc__row, .st-stats|li'],
    ['.j-wrap', '.j-title', '.j-intro, .j-count', '.j-grid|.j-card, .j-chips|.j-chip'],
    ['.ja', '.ja-title', '.ja-by, .ja-content', '.ja-tags|.ja-tag, .ja-related .j-grid|.j-card'],
    ['.s786-coll', '.s786-coll__title', '.s786-coll__desc', '.s786-coll__grid|.s786-card, .s786-coll__tabs|.s786-tabs__item'],
    ['.s786-cart', '.s786-cart__title', '.s786-cart__summary', '.s786-cart__items|.s786-cart__item'],
    ['.s786-search', '.s786-search__title', '.s786-search__field', '.s786-search__grid|.s786-result'],
    ['.s786-404', '.s786-404__num', '.s786-404 p', ''],
    ['.s786-about', '.s786-about__title', '.s786-about__body', '.s786-about__stats|li'],
    ['.s786-try', '.s786-try__kicker', '.s786-try__banner-text', '.s786-try__cards|.s786-try__card'],
    ['.s786-pdp', '.s786-pdp__title', '.s786-pdp__short, .s786-pdp__price', '.s786-pdp__thumbs|.s786-pdp__thumb, .s786-pdp__reclist|.s786-rec']
  ];

  function generic(root) {
    GENERIC.forEach(function (row) {
      q(row[0], root).forEach(function (s) {
        if (row[1]) AA(row[1], s, 'words', { stagger: 0.05 });
        if (row[2]) AA(row[2], s, 'fade-up', { delay: 0.12 });
        if (row[3]) {
          row[3].split(',').forEach(function (pair) {
            var bits = pair.trim().split('|');
            if (bits.length !== 2) return;
            q(bits[0], s).forEach(function (wrap) {
              A(wrap, 'stagger', { children: bits[1], child: 'fade-up', stagger: 0.07, dur: 0.8, start: 'top 92%' });
            });
          });
        }
      });
    });
    hov('.s786-card, .j-card, .st-cert, .s786-try__card', root, 'data-tilt', '4');
  }

  /* ---------------------------------------------------------------- run */
  function tagAll(root) {
    root = root || document;
    try {
      hero(root); shades(root); carousel(root); featured(root);
      campaign(root); spotlight(root); vip(root); footer(root); generic(root);
    } catch (e) {
      if (window.console) console.warn('[786 motion+]', e);
    }
    if (window.Motion && window.Motion.scan) window.Motion.scan(root);
  }

  window.MotionPlus = { tag: tagAll, A: A };

  function boot() {
    tagAll(document);
    document.addEventListener('shopify:section:load', function (e) { tagAll(e.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
